//own imports
import './Error.css';
//react imports
import React, {
    useEffect
} from 'react';
import { Link } from 'react-router-dom';

const Scan = () => {

    //Page title
    useEffect(() => {
        document.title = 'Scan';
    },[]);

    return (
        <div style={{minHeight:'100vh'}}>
            <h1 className="error404">404</h1>
            <h2 className="errorH2">PAGE NOT FOUND</h2>
            <p className="errorP">The page you are looking for might have been removed, had its name changed or is temporarily unavailable.</p>
            <Link className="btn-secondary" to='/'>Back to Home</Link>
        </div>
    );
};

export default Scan;